const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 60,
    justifyContent: 'space-between',
    padding: '12px 30px 12px 25px',
    borderTop: '1px solid hsl(210, 10%, 89%)',
  },
  textField: {
    resize: 'none',
    outline: 'none',
    width: '100%',
    overflow: 'scroll',
    maxHeight: 100,
  },
  button: {
    display: 'flex',
    border: 'none',
    background: 'none',
    marginLeft: 30,
    transition: 'transform .2s',
    outline: 'none',
    '&:hover': {
      transform: 'scale(1.05)',
    },
    '&:active': {
      transition: 'none',
      transform: 'scale(.95)',
    },
  },
  root: {
    fontFamily: 'inherit',
    fontSize: 14,
  },
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessageForm/styles.js